import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const DeadlineItem = ({ deadline }) => {
  const navigate = useNavigate();

  const getUrgencyStyles = (urgency) => {
    switch (urgency) {
      case 'critical':
        return 'bg-error/10 border-error/30 text-error';
      case 'high':
        return 'bg-warning/10 border-warning/30 text-warning';
      case 'medium':
        return 'bg-accent/10 border-accent/30 text-accent';
      default:
        return 'bg-muted border-border text-muted-foreground';
    }
  };

  const getUrgencyIcon = (urgency) => {
    switch (urgency) {
      case 'critical':
        return 'AlertCircle';
      case 'high':
        return 'AlertTriangle';
      case 'medium':
        return 'Clock';
      default:
        return 'Info';
    }
  };

  const handleClick = () => {
    if (deadline?.type === 'permit' && deadline?.permitId) {
      // Dispatch event to open permit details
      const event = new CustomEvent('openPermitDetails', {
        detail: { permitId: deadline?.permitId }
      });
      window.dispatchEvent(event);
      // Navigate to permits page where the detail panel will open
      navigate('/permits');
    } else if (deadline?.type === 'event' && deadline?.eventId) {
      // Dispatch event to open event modal
      const event = new CustomEvent('openEventDetails', {
        detail: { eventId: deadline?.eventId }
      });
      window.dispatchEvent(event);
      // Navigate to calendar page where the event modal will open
      navigate('/calendar');
    }
  };

  return (
    <div 
      className="flex items-start gap-3 md:gap-4 p-3 md:p-4 bg-card border border-border rounded-lg smooth-transition hover:shadow-md hover:border-primary/30 cursor-pointer"
      onClick={handleClick}
    >
      <div className={`${getUrgencyStyles(deadline?.urgency)} border rounded-lg p-2 flex-shrink-0`}>
        <Icon name={getUrgencyIcon(deadline?.urgency)} size={16} className="md:w-5 md:h-5" />
      </div>
      <div className="flex-1 min-w-0 space-y-1">
        <div className="flex items-start justify-between gap-2">
          <h4 className="text-sm md:text-base font-semibold text-foreground line-clamp-1">
            {deadline?.title}
          </h4>
          <span className="text-xs md:text-sm font-medium text-muted-foreground whitespace-nowrap">
            {deadline?.daysLeft}
          </span>
        </div>
        <p className="text-xs md:text-sm text-muted-foreground line-clamp-1">
          {deadline?.project}
        </p>
        <div className="flex items-center gap-1.5 text-xs text-muted-foreground">
          <Icon name="Calendar" size={12} className="md:w-3.5 md:h-3.5" />
          <span>{deadline?.date}</span>
        </div>
      </div>
    </div>
  );
};

export default DeadlineItem;